//
import Service from '@/services/API/Service'
import PosSaleModel from '@/models/POS/PosSale'

/**
 * 
 */
export default class PosSale extends Service {

  /**
   * 
   */
  static genPay() {
    return this.shape().one('pay')
  }

  /**
   * 
   */
  static mapPayment(payment, change) {

  }

  /**
   * 
   */
  static mapSaleCreditPayment(payment, change) {
    
    // required
    let paymentAmount           = parseFloat(payment.payment)
    let paymentChangeAmount     = parseFloat(change)
    // let paymentDetail           = Object(payment.paymentDetail)
    let paymentMethodId         = parseInt(payment.paymentMethod)
    // let paymentSaleCreditNoteId = parseInt(paymentDetail.sl_sale_credit_note_id)

    // calc payment amount
    let paymentCashAmount       = paymentAmount - paymentChangeAmount

    // result
    return {
      amount_payment: paymentCashAmount,
      id_sale_payment_id: paymentMethodId,
    }
  }

  /**
   * 
   */
  static model() {
    return PosSaleModel
  }

  /**
   * 
   */
  static pay() {
    return this.genPay().attach({})
  }
}